


<div class="container">
  <div class="card">
   <H4>
    The MMS contains Vanguard Trade Secret information. The MMS is highly confidential and for the use of authorized Vanguard employees only.
    Information from the MMS may not be shared outside of the Vanguard.
    By using the MMS you confirm that you are an authorized user.
  </H4>
  </div>
</div>
